import '@css/main.scss';

import {Archive} from './components/Archive';
import {Header} from './components/Header';
import {Modal} from './components/Modal';
import {FilterForm} from './components/FilterForm';
import {AjaxScroll} from './components/AjaxScroll';
import {Tabs} from './components/Tabs';
import {Accordion} from './components/Accordion';
import {Slider} from './components/Slider';
import {Parallax} from './components/Parallax';
import {RoomTabs} from './components/RoomTabs';
import {Map} from './components/Map';

window.onload = () => {
  new Archive()
  new Header()
  new Modal()
  new FilterForm()
  new AjaxScroll()
  new Tabs()
  new Accordion()
  new Slider()
  new Parallax()
  new RoomTabs()
  new Map()
}
